import { render, staticRenderFns } from "./select-dropdown.vue?vue&type=template&id=534e8eb0"
import script from "./select-dropdown.vue?vue&type=script&lang=js"
export * from "./select-dropdown.vue?vue&type=script&lang=js"
import style0 from "./select-dropdown.vue?vue&type=style&index=0&id=534e8eb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports